import { Storage } from 'aws-amplify';
import axios from 'axios';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { SendBulletinNotiModal } from '.';
import './Bulletin.css';
import DeleteModal from './DeleteModal';
import LinesEllipsis from 'react-lines-ellipsis'

const BulletinList = ({ bulletin, onDelete, badgeID, loginList }) => {
    const [dropdown, setShowDropdown] = useState(false)
    const showDropDown = () => setShowDropdown(!dropdown)

    const [modal, setOpenModal] = useState(false)
    const openModal = () => setOpenModal(!modal)
    const closeModal = () => setOpenModal(!modal)

    const [imageCoverUrl, setImageCoverUrl] = useState('')
    const [showEdit, setShowEdit] = useState(false)
    const [showSelfEdit, setShowSelfEdit] = useState(false)

    const [notiModal, setOpenNotiModal] = useState(false)
    const openNotiModal = () => setOpenNotiModal(!notiModal)
    const closeNotiModal = () => setOpenNotiModal(!notiModal)

    const ref = useRef();

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (dropdown && ref.current && !ref.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [dropdown, ref]);

    useEffect(() => {
        if (loginList) {
            const loginListFromParent = loginList;

            const permit = loginListFromParent.some((item) =>
            (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit")) 
            || 
            (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("edit"))
            )

            if (permit) {
                setShowEdit(true)
            }

            if (bulletin.createdByID === badgeID || loginListFromParent.some((item) =>
            (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit")))) {
                setShowSelfEdit(true)
            }
        }

    }, [loginList, badgeID, bulletin.createdByID])

    useEffect(() => {
        fetchImageCover()

        async function fetchImageCover() {
            const imageCoverUrl = await Storage.get(bulletin.imageCover)
            setImageCoverUrl(imageCoverUrl)
        }
    }, [bulletin.imageCover])
    
    const sendNotification = (noti) => {
        sendNewNotification(noti);
        const url = REACT_APP_API_BACKEND_URL + '/api/bulletinboard/pushnoti';
        const notification = noti.notification
        const requests = [];

        for (let i = 0; i < notification.length; i++) {
            requests.push(axios.post(url, {
                id: notification[i].id,
                title: notification[i].title,
                employee: notification[i].employee.toLowerCase()
            }))
        }

        axios.all(requests)
        .then(axios.spread((...responses) => {
            alert('Notification has been successfully sent!');
            setTimeout(()=>{
                setOpenNotiModal(!notiModal)
            }, 500);
        })).catch(err => {
            console.error(err)
        })
    }

    const sendNewNotification = (noti) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/bulletinboard/newpushnoti';
        const notification = noti.notification
        const requests = [];

        for (let i = 0; i < notification.length; i++) {
            requests.push(axios.post(url, {
                id: notification[i].id,
                title: notification[i].title,
                employee: notification[i].employee.toLowerCase()
            }))
        }

        axios.all(requests)
        .then(axios.spread((...responses) => {
            
        })).catch(err => {
            console.error(err)
        })
    }

    const history = useHistory();
    
    return (
        <Col>
            <Card 
                id={bulletin.bbID} 
                className='text-center' 
                style={{
                    height: '100%',
                    padding: '15px', 
                    borderRadius: '20px',
                    boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 20%)'
                }}
            >
                <Row style={{marginBottom: '5px'}}>
                    <Col md={6} style={{textAlign: 'left'}}>
                        <div 
                            className={`${bulletin.liveStatus === 'live' ? 'btn btn-success' : bulletin.liveStatus === 'end' ? 'btn btn-danger' : 'btn btn-warning'}`} 
                            style={{padding: '5px 25px', borderRadius: '50px', cursor: 'default', textTransform: 'capitalize'}}
                        >
                            {bulletin.liveStatus}
                        </div>
                    </Col>
                    <Col md={6} style={{textAlign: 'right'}}>
                        {showSelfEdit && showEdit &&
                        <div className='ellipsis-menu' ref={ref}>
                            <FaIcons.FaEllipsisH onClick={showDropDown} style={{cursor: 'pointer'}} />
                            { dropdown &&
                                <div className='dropdown-content'>
                                    <button className='ellipsis-menu-btn' onClick={() => history.push(`/bulletinboard/edit/${bulletin.bbID}`)}>Edit</button>
                                    <button className='ellipsis-menu-btn' onClick={openModal}>Delete</button>
                                        <DeleteModal show={modal} handleClose={closeModal} id={bulletin.bbID} onDelete={onDelete} />
                                    <button className='ellipsis-menu-btn' onClick={openNotiModal}>Send Notification</button>
                                        <SendBulletinNotiModal 
                                            show={notiModal}
                                            handleClose={closeNotiModal}
                                            bulletin={bulletin}
                                            onPushNoti={sendNotification}
                                        />
                                </div>
                            }
                        </div>
                        }
                    </Col>
                </Row>
                <div className='view-bulletin-link' onClick={() => history.push(`/bulletinboard/view/${bulletin.bbID}`)}>
                    <div className='bulletin-img'>
                        <Card.Img variant='top' src={imageCoverUrl} className='bulletin-img' style={{width: '100%'}}/>
                    </div>
                    <Card.Body style={{height: '190px', display: 'flex', flexDirection: 'column'}}>
                        <Card.Title style={{fontSize: '1rem'}}><strong>
                            <LinesEllipsis
                                text={bulletin.title}
                                maxLine='2'
                                ellipsis='...'
                                trimRight
                                basedOn='words'
                            />
                            </strong></Card.Title>
                        <div style={{marginTop: 'auto', fontSize: '14px'}}>
                            <Card.Text>Created on {moment(bulletin.createdDate).format("DD/MM/YYYY")}</Card.Text> 
                            <Card.Text>By {bulletin.createdBy}</Card.Text>
                            <Card.Text>{bulletin.viewCount > 1 ? <>{bulletin.viewCount} Views</> : <>{bulletin.viewCount} View</>}</Card.Text>
                        </div>
                    </Card.Body>
                </div>
            </Card>
        </Col>
    )
}

export default BulletinList
